<template>
  <div :class="'grid_inner ' + (isExtra ? '' : 'fw500')">
    <div class="cell">
      <BaseCheckbox
        :value="isConfirmed.value"
        class="mr-2"
        :disabled="isLocked"
        @input="setConfirmedChanges(!isConfirmed.value)"
      />
      {{
        work.is_hourly === 1 || isExtra
          ? $formatTime(report.approved_report)
          : report.approved_report + ' ' + work.measure
      }}
    </div>
    <div class="d-flex">
      <div class="cell">{{ work.name }}</div>
      <div v-if="notes" class="cell">
        {{ isExtra ? report['work_extras_report_notes'] : report['employee_work_day_reports_notes'] }}
      </div>
      <div v-if="notes" class="cell">
        {{ report['selected_block'] || '—' }}
      </div>
    </div>
  </div>
</template>

<script>
import BaseCheckbox from "components/base/BaseCheckbox";

export default {
  name: "StatisticProjectReportsBlankConfirmTableByDaysItem",
  components: {BaseCheckbox},
  props: {
    isExtra: Boolean,
    work: {
      type: Object,
      default: () => {
        return {}
      }
    },
    report: {
      type: Object,
      default: () => {
        return {}
      }
    },
    confirmed: {
      type: Array,
      default: () => {
        return []
      }
    },
    onUpdate: {},
    notes: Boolean,
    currentBillId: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    isLocked() {
      const isEmptyBillId = (value) => {
        return value === null || value === undefined || value === '' || value === 'null'
      }
      const isSameBillId = (value, currentBillId) => {
        if (isEmptyBillId(value) || isEmptyBillId(currentBillId)) return false
        return String(value) === String(currentBillId)
      }
      return this.report?.client_report_status === 'signed'
        || this.report?.client_report_status === 'approved'
        || (!isEmptyBillId(this.report?.client_bill_id) && !isSameBillId(this.report?.client_bill_id, this.currentBillId))
    },
    isConfirmed() {
      return {
        value: this.confirmed.includes(this.report.id)
      }
    }
  },
  methods: {
    setConfirmedChanges(value) {
      if (this.isLocked) return
      if (this.onUpdate) this.onUpdate([this.report.id], value)
    }
  }
}
</script>
